import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=ae3a994a&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=ts"
export * from "./MainNavbar.vue?vue&type=script&lang=ts"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=ae3a994a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3a994a",
  null
  
)

export default component.exports